import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { Modal, Blockquote } from "@wfp/ui";

import { Report } from "data-handler/ducks/stores";

export const isReportOlderThanCurrentMonth = (report: Report): boolean => {
  const now = moment();
  const currentYear = now.year();
  const currentMonth = now.month() + 1;
  return (
    report.year < currentYear ||
    (report.year === currentYear && report.month < currentMonth)
  );
};

type RecalculateWarningModalProps = {
  open: boolean;
  period: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const RecalculateWarningModal: React.ComponentType<RecalculateWarningModalProps> = ({
  open,
  period,
  onConfirm,
  onCancel,
}) => {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      type="warning"
      modalHeading={intl.formatMessage({
        id: "RecalculateWarning.heading",
        defaultMessage: "Recalculate report",
      })}
      primaryButtonText={intl.formatMessage({
        id: "RecalculateWarning.confirm",
        defaultMessage: "Recalculate",
      })}
      secondaryButtonText={intl.formatMessage({
        id: "ModalExtended.cancel",
        defaultMessage: "Cancel",
      })}
      onRequestSubmit={onConfirm}
      onSecondarySubmit={onCancel}
      onRequestClose={onCancel}
    >
      <Blockquote kind="warning">
        <FormattedMessage
          id="RecalculateWarning.body"
          defaultMessage="You are about to recalculate the {period} report, which is from a past month. Recalculating may overwrite previously reported figures. Are you sure you want to continue?"
          values={{ period: <strong>{period}</strong> }}
        />
      </Blockquote>
    </Modal>
  );
};

export default RecalculateWarningModal;
